import * as React from "react";
import * as ReactDOM from "react-dom";
import {AppRoutes} from "./pages/AppRoutes";
ReactDOM.render(
        <AppRoutes/>,
    document.getElementById("app-root"),
);



// WEBPACK FOOTER //
// ./src/index.tsx